import React from "react";
import man from "./../../../assets/img/man.jpg";
import woman from "./../../../assets/img/women.jfif";
import menu from "./../../../assets/img/icons/menu.svg";
import {
  BellFilled,
  LogoutOutlined,
  SettingOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";
import logo from "./../../../assets/img/logo.svg";
import { Button, Badge, Popover, Tooltip, Avatar, Row, Col } from "antd";
import { logOut } from "../../../redux/actions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import history from "../../../const/history";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const TopMenu = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const logOut = () => {
    localStorage.removeItem("access_token");
    props.logOut();
    history.push("/");
  };
  console.log(props);

  const content = () => {
    return (
      <div className="profil-info">
        <Row className="border-bottom pt-1 pb-1 mb-10">
          <Col xs={4}>
            <Avatar size={38} src={props.gender === 0 ? man : woman} />
          </Col>
          <Col className="border-right" xs={20}>
            <div className="flex w-100 h-100 flex-align-center pr-1">
              <h3>{props.name}</h3>
            </div>
          </Col>
        </Row>
        <div className="w-100  flex flex-between">
          <Button>
            <SettingOutlined /> <span>{t("settings")}</span>
          </Button>
          <Button onClick={logOut}>
            <span>{t("logOut")}</span> <LogoutOutlined />
          </Button>
       </div>
      </div>
    );
  };


  const contentMenu = () => {
    return (
      <div className="profil-info  inteqrations">
        {/* <Row  className={'pr-5 mr-5 mt-10'}>
          <Col xs={12} style={{borderRight:'1px solid #E8E8E8'}}>
            <Link to={'/'} className={'flex mb-10 w-100 text-black flex-align-center justify-center dir-column'}>
              <img className={'topmenu-img'} src={map} alt=""/>
              <p className={'text-dark'}>Xəritə</p>
            </Link>
          </Col>
          <Col xs={12} style={{borderBottom:'1px solid #E8E8E8' , transform:'translate(-1px, 1px)'}}>
            <Link to={'/integratons/work-contiuned'} className={'flex mb-10 w-100 text-black flex-align-center justify-center dir-column'}>
              <img className={'topmenu-img'} src={calendar} alt=""/>
              <p className={'text-dark'}>İşə davamiyyət</p>
            </Link>
          </Col>
          <Col xs={12} style={{borderTop:'1px solid #E8E8E8'}}>
            <Link to={'/integratons/analyzes'} className={'flex mb-10 w-100 text-black flex-align-center justify-center dir-column'}>
              <img className={'topmenu-img'} src={stansiya} alt=""/>
              <p className={'text-dark'}>Metroloji stansiyalar  </p>
            </Link>
          </Col>
          <Col xs={12} style={{borderLeft:'1px solid #E8E8E8', transform:'translate(-1px, 1px)'}}>
            <Link to={'/integratons/cars'} className={'flex mb-10 w-100 text-black flex-align-center justify-center dir-column'}>
              <img className={'topmenu-img'} src={car} alt=""/>
              <p className={'text-dark'}>Avtomobil</p>
            </Link>
          </Col>
        </Row> */}
      </div>
    );
  };

  return (
    <div className="position-relative">
      <div className="top-menu flex-align-center flex ">
        {props.showDrawerButton ? (
          <Button type="primary" className="mr-20" onClick={props.toggleDrawer}>
            {props.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </Button>
        ) : null}
        {props.collapsed ? (
          <Link to="/">
            <img className="animated fadeIn" src={logo} alt="" />
          </Link>
        ) : null}
        <div className="top-menu-navigation">
        

          <Link to={`/reports`}>
            <Tooltip placement="bottomRight" title={t("notifications")}>
              <Badge>
                <Avatar
                  className="circle-notification"
                  size={35}
                  icon={<BellFilled />}
                />
              </Badge>
            </Tooltip>
          </Link>

          <Tooltip placement="bottomRight" title={props.name}>
            <Popover
              className="ml-20"
              placement="bottomRight"
              content={content()}
              trigger="click"
            >
              <Avatar size={35} src={props.gender === 0 ? man : woman} />
            </Popover>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = ({ user }) => {
  console.log(user);
  return {
    name: user.data.user,
    gender: user.data.userGender,
  };
};
export default connect(mapStateToProps, { logOut })(TopMenu);
